import PropTypes from "prop-types"
import React from "react"
import {FormGroup, Label} from "reactstrap"
import Select from "react-select"
import {MultiSelect} from "react-multi-select-component"
import {filtrarEmpresas, filtrarEmpresaSelect} from "../../helpers/utils"

const FormFilterCompany = props => {
    const { attribute, placeholder, description, value, setValue, options, multiple, hasSelectAll, disabled } = props

    const ArrowRenderer = ({ expanded }) =><span className="arrow"></span>
    const ClearRenderer = () =><span className="clear"></span>

    return (
        <React.Fragment>
            <FormGroup className="mt-3 mb-0">
                <Label htmlFor={ (attribute || 'empresa') + "-select" }>
                    { description || ( 'Empresa' + (multiple ? '(s)' : '')) }
                </Label>
                { multiple && <MultiSelect
                    id={ (attribute || 'empresa') + "-multi-multi-select" }
                    name={ (attribute || 'empresa') + "-multi-multi-select" }
                    options={ (options || []) }
                    value={value}
                    onChange={ value => { setValue(value) } }
                    labelledBy="Selecione"
                    disableSearch={false}
                    filterOptions={filtrarEmpresas}
                    overrideStrings={{
                        "allItemsAreSelected": "Todos selecionados.",
                        "clearSearch": "Limpar",
                        "clearSelected": "Deselecionar todos",
                        "noOptions": "Não há opções",
                        "search": "Pesquisar",
                        "selectAll": "Selecionar todos",
                        "selectAllFiltered": "Selecionar todos",
                        "selectSomeItems": "Selecione",
                        "create": "Criar",}
                    }
                    hasSelectAll={ hasSelectAll }
                    ClearIcon={<ClearRenderer />}
                    ClearSelectedIcon={<ClearRenderer />}
                    ArrowRenderer={ ArrowRenderer }
                    disabled={disabled}
                /> }
                { !multiple &&
                    <Select
                        id={ (attribute || 'empresa') + "-select" }
                        name={ (attribute || 'empresa') + "-select" }
                        className="basic-single"
                        options={ (options || []) }
                        placeholder={ placeholder || "Digite a empresa..." }
                        isClearable={true}
                        isSearchable={true}
                        filterOption={filtrarEmpresaSelect}
                        noOptionsMessage={() => "Nenhuma empresa encontrada"}
                        onChange={opcao => {
                            // react-select entrega a opção escolhida (ou null ao limpar), não um evento
                            if (setValue) setValue(opcao ? opcao.value : undefined)
                        }}
                        value={ value ? (options || [])?.find(e => e.value === value) : undefined}
                        isDisabled={disabled}
                    />
                }
            </FormGroup>
        </React.Fragment>
    )
}

FormFilterCompany.propTypes = {
    attribute: PropTypes.string,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    value: PropTypes.any,
    setValue: PropTypes.func,
    options: PropTypes.any,
    disabled: PropTypes.bool,
    hasSelectAll: PropTypes.bool
}

export default FormFilterCompany
